import { useContext } from 'react'

import type { FeatureFlags } from './uiConfig'
import { UiConfigContext } from './uiConfigContext'

export const useUiConfig = () => useContext(UiConfigContext)

export const useFeatureFlag = (flag: keyof FeatureFlags) => {
  const { config } = useUiConfig()
  return Boolean(config.featureFlags?.[flag])
}
